import { cardItems } from "../scripts/vars/cardItems";

export const getTableTitle = (glbName, folderName, typeName) => {
    const table = cardItems[folderName][typeName].find((table) => table.glbName === glbName);
    if (!table) {
        console.warn(
            `[getTableTitle.js]: Объект с glbName "${glbName}" — не был найден в cardItems.${folderName}.${typeName}`,
        );
        return "";
    }
    return table.title;
};
